import { ThemeContext } from '@planity/context/theme_context';

export const ThemeContextProvider = ({ children }) => {
	return <ThemeContext.Provider value={{}}>{children}</ThemeContext.Provider>;
};
